<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 11:43:04
 * @FilePath: 
 * @Description: 个人业绩
-->
<template>
  <div class="c-p-t-20 full_page_grey">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>
    <div class="total_count_con">
      <p class="c-ft-34 c-m-b-10">{{ singleTotalBonus }}</p>
      <p class="c-ft-26">总提成</p>
    </div>
    <div
      class="ticheng_title_con"
      @click="handleToTichengPage('SalesPromotionTicheng')"
    >
      <p class="ticheng_left_con">项目推销提成</p>
      <p><img src="@/assets/images/newGrayRightArrow.png" alt="" /></p>
    </div>
    <ul class="statistics_item_con">
      <li>
        <p class="c-ft-24">推销业绩</p>
        <div class="statistics_count_con">{{ productObj.Amount }}</div>
      </li>
      <li>
        <p class="c-ft-24">推销项目数</p>
        <div class="statistics_count_con">{{ productObj.Count }}</div>
      </li>
      <li>
        <p class="c-ft-24">项目提成</p>
        <div class="statistics_count_con">{{ productObj.Commission }}</div>
      </li>
    </ul>
    <div
      class="ticheng_title_con"
      @click="handleToTichengPage('SaleGoodsTicheng')"
    >
      <p class="ticheng_left_con">商品销售提成</p>
      <p><img src="@/assets/images/newGrayRightArrow.png" alt="" /></p>
    </div>
    <ul class="statistics_item_con">
      <li>
        <p class="c-ft-24">销售业绩</p>
        <div class="statistics_count_con">{{ goodsObj.Amount }}</div>
      </li>
      <li>
        <p class="c-ft-24">销售商品数</p>
        <div class="statistics_count_con">{{ goodsObj.Count }}</div>
      </li>
      <li>
        <p class="c-ft-24">销售提成</p>
        <div class="statistics_count_con">{{ goodsObj.Commission }}</div>
      </li>
    </ul>
    <div
      class="ticheng_title_con"
      @click="handleToTichengPage('SaleCardTicheng')"
    >
      <p class="ticheng_left_con">售卡充值提成</p>
      <p><img src="@/assets/images/newGrayRightArrow.png" alt="" /></p>
    </div>
    <ul class="statistics_item_con">
      <li>
        <p class="c-ft-24">售卡充值金额</p>
        <div class="statistics_count_con">{{ memberCardObj.Amount }}</div>
      </li>
      <li>
        <p class="c-ft-24">推销会员人数</p>
        <div class="statistics_count_con">{{ memberCardObj.Count }}</div>
      </li>
      <li>
        <p class="c-ft-24">售卡充值提成</p>
        <div class="statistics_count_con">{{ memberCardObj.Commission }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getSinglePerformance } from "@/api/performance";
export default {
  name: "SinglePerformance",
  props: {},
  data() {
    return {
      singleTotalBonus: "--",
      productObj: {},
      goodsObj: {},
      memberCardObj: {},
    };
  },
  components: { DateTabCom },
  created() {},

  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetSinglePerformance();
    });
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      if (this.dateType !== 4) {
        this.handleGetSinglePerformance();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.handleGetSinglePerformance();
    },
    handleGetSinglePerformance() {
      const queryData = {
        TimeType: this.dateType,
        VpnId: this.$store.state.vpnId,
      };
      if (this.dateType == 4) {
        queryData.BeginTime = this.startDate;
        queryData.EndTime = this.endDate;
      }
      getSinglePerformance(queryData).then((res) => {
        this.singleTotalBonus = res.TotalCommission;
        this.productObj = res.ProductTotal;
        this.goodsObj = res.GoodsTotal;
        this.memberCardObj = res.MemberCardTotal;
      });
    },
    handleToTichengPage(url) {
      this.$router.push({
        name: url,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.total_count_con {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 50px auto;
  background: var(--tc);
  color: #fff;
}
.ticheng_title_con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  // background: #fff;
  font-size: 32px;
  font-weight: bold;

  img {
    width: 20px;
    height: 28px;
  }
  .ticheng_left_con {
    padding-left: 20px;
    position: relative;
    &:before {
      content: "";
      width: 7px;
      height: 30px;
      background: var(--tc);
      border-radius: 5px;
      position: absolute;
      left: 0;
      top: 3px;
    }
  }
}
.statistics_item_con {
  display: flex;
  padding: 20px;
  margin-bottom: 20px;
  li {
    flex: 1;
    padding: 30px 0;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;

    &:nth-child(3n) {
      margin-right: 0;
    }
    .statistics_count_con {
      font-size: 30px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
</style>
